import BasePageStructure from 'src/components/BasePageStructure';
import styles from './TransferPool.module.css';
import { Box, Button, IconButton, Typography } from '@mui/material';
import SearchBar from 'src/components/SearchBar';
import RefreshIcon from '@mui/icons-material/Refresh';
import { useState } from 'react';
import { EmployeeState, EmployeeFilter_In, EmployeesService } from 'src/pehra-ts-client';
import { useQuery } from '@tanstack/react-query';
import NewEmployeesModal from './components/NewEmployeesModal';
import ConditionalRenderQuery from 'src/components/ConditionalRenderQuery';
import EmployeeTable from './components/EmployeeTable';

export interface ITransferPool {}

const TransferPool: React.FC<ITransferPool> = () => {
  const [searchText, setSearchText] = useState<string>('');
  const [openNewEmployeeModal, setOpenNewEmployeeModal] = useState<boolean>(false);
  const [employeeFilter, setEmployeeFilter] = useState<EmployeeFilter_In>({
    // id: null,
    // // name: null,
    // // father_name: null,
    // rank: null,
    // pno_number: null,
    // home_district: null,
    // education: null,
    // category: null,
    // caste: null,
    // special_qualifications: null,
    state: EmployeeState.AVAILABLE_FOR_TRANSFER
    // current_office_id: null,
    // current_office_name: null,
    // current_office_type: null
  });

  const handleSearchChange = (text: string) => {
    setSearchText(text);
  };

  const fetchEmployeesQuery = useQuery({
    queryKey: ['employeesElligibleToTransfer'],
    queryFn: () => EmployeesService.getAllEmployees(employeeFilter)
  });

  const employeePositionComponent = (
    <Box className={styles.employeePositionContainer}>
      <Box className={styles.searchContainer}>
        <Box>
          <SearchBar placeholder="Search Employees" searchText={searchText} handleSearchChange={handleSearchChange} />
        </Box>
      </Box>
      <EmployeeTable rows={fetchEmployeesQuery.data?.employees} />
    </Box>
  );

  return (
    <BasePageStructure title="Available for Transfers">
      <Box className={styles.container}>
        <ConditionalRenderQuery
          status={fetchEmployeesQuery.status}
          success={() => {
            return employeePositionComponent;
          }}
        />
      </Box>
    </BasePageStructure>
  );
};

export default TransferPool;
